/**
 * Sonner Toaster Component
 * @module components/ui/sonner
 *
 * Wrapper para o Toaster do sonner com tema integrado ao projeto.
 */

import { Toaster as SonnerToaster } from 'sonner';

type ToasterProps = React.ComponentProps<typeof SonnerToaster>;

/**
 * Toaster component para notificacoes toast
 *
 * Deve ser incluido uma vez no root da aplicacao (App.tsx)
 *
 * @example
 * ```tsx
 * // Em App.tsx
 * function App() {
 *   return (
 *     <>
 *       <Routes />
 *       <Toaster />
 *     </>
 *   );
 * }
 * ```
 */
export function Toaster({ ...props }: ToasterProps) {
  return (
    <SonnerToaster
      position="top-right"
      toastOptions={{
        classNames: {
          toast: 'group toast bg-background text-foreground border-border shadow-lg',
          description: 'text-muted-foreground',
          actionButton: 'bg-primary text-primary-foreground',
          cancelButton: 'bg-muted text-muted-foreground',
          success:
            'border-green-500/20 bg-green-50 text-green-900 dark:bg-green-950 dark:text-green-100',
          warning:
            'border-yellow-500/20 bg-yellow-50 text-yellow-900 dark:bg-yellow-950 dark:text-yellow-100',
          error: 'border-red-500/20 bg-red-50 text-red-900 dark:bg-red-950 dark:text-red-100',
          info: 'border-blue-500/20 bg-blue-50 text-blue-900 dark:bg-blue-950 dark:text-blue-100',
        },
      }}
      {...props}
    />
  );
}

export { SonnerToaster };
